import { createReducer } from 'redux-act';

import {
  CLASS_FETCH_DATA_INIT,
  CLASS_FETCH_DATA_SUCCESS,
  CLASS_FETCH_DATA_FAIL,
  CLASS_DELETE_INIT,
  CLASS_DELETE_SUCCESS,
  CLASS_DELETE_FAIL,
  CLASS_CLEAR_DATA,
  CLASS_CREATE_INIT,
  CLASS_CREATE_SUCCESS,
  CLASS_CREATE_FAIL,
  CLASS_MODIFY_INIT,
  CLASS_MODIFY_SUCCESS,
  CLASS_MODIFY_FAIL,
  CLASS_CLEAN_UP,
  CLASS_CLEAR_DATA_LOGOUT
} from '../../actions/classes';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const classesReducer = createReducer(
  {
    [CLASS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [CLASS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.classes,
      loading: false,
      error: null
    }),
    [CLASS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [CLASS_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [CLASS_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [CLASS_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [CLASS_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [CLASS_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [CLASS_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [CLASS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
